import AmountInputs from './AmountInputs'
import DepositFormPart from './DepositFormPart'
import FollowUp from './FollowUp'
import InputsContainer from './InputsContainer'
import ResultBoard from './ResultBoard'
import SavingsInputs from './SavingsInputs'
import { TabLink, TabLinks } from './TabLinks'

export {
  DepositFormPart,
  FollowUp,
  AmountInputs,
  SavingsInputs,
  ResultBoard,
  InputsContainer,
  TabLinks,
  TabLink,
}
